export class EmailAddress {

  personId!: string;
  emailAddress!: string;
  relationshipTypeCode!: string;

}
